import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  NavContainer,
  NavContent,
  Logo,
  NavLinks,
  NavLink,
  UserInfo,
  UserDetails,
  UserName,
  UserRole,
  UserAvatar,
  LogoutButton
} from '../styles/Navigation.styles';



function Navigation() {
  const location = useLocation();
  const { user, userType, smartLogout } = useAuth();

  const handleLogout = async () => {
    if (window.confirm('Are you sure you want to logout?')) {
      await smartLogout();
    }
  };

  const getInitials = (name) => {
    if (!name) return userType === 'admin' ? 'AD' : 'PR';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  const getUserDisplayName = () => {
    return user?.name || user?.fullName || user?.firstName || 'User';
  };

  return (
    <NavContainer>
      <NavContent>
        <Logo>BidMaster Pro</Logo>
        
        <NavLinks>
          {userType === 'admin' && (
            <NavLink 
              to="/admin" 
              isActive={location.pathname.startsWith('/admin')}
            >
              Admin Portal
            </NavLink>
          )}
          {userType === 'presenter' && (
            <NavLink 
              to="/presenter" 
              isActive={location.pathname.startsWith('/presenter')}
            >
              Presenter Portal
            </NavLink>
          )}
        </NavLinks>

        <UserInfo>
          <UserDetails>
            <UserName>{getUserDisplayName()}</UserName>
            <UserRole>{userType} Dashboard</UserRole>
          </UserDetails>
          <UserAvatar title={`${getUserDisplayName()} (${userType})`}>
            {getInitials(getUserDisplayName())}
          </UserAvatar>
          <LogoutButton onClick={handleLogout} title="Logout">
            🚪 Logout
          </LogoutButton>
        </UserInfo>
      </NavContent>
    </NavContainer>
  );
}

export default Navigation; 